export const CampaignsQueryKeys = {
  GET_ALL: (merchantId: string, venueIds?: string[]) => ['self-service-promotions', 'promotions', merchantId, venueIds],
  GET_SINGLE: (merchantId: string, campaignId: string) => [
    'self-service-promotions',
    'promotions',
    merchantId,
    campaignId,
  ],
  GET_ITEM: (menuId: string, itemId: string) => ['menu', 'item', menuId, itemId],
  GET_CONFIG: (merchantId: string, venueIds: string[]) => [
    'self-service-promotions',
    'config_v2',
    merchantId,
    venueIds,
  ],
  GET_AUTHOR: (authorId: string) => ['users', authorId],
  ADS: {
    VENUES: {
      GET_ALL_CAMPAIGNS: (venueId: string) => ['venue-ads', venueId],
      GET_CAMPAIGN: (venueId: string, campaignId: string) => ['venue-ads', venueId, campaignId],
      GET_CAMPAIGN_CONFIG: ({ venueId, country }: { venueId: string | undefined; country: Country | undefined }) => [
        'venue-ads',
        'configuration',
        venueId,
        country,
      ],
      GET_CAMPAIGN_COUNT: (venueId: string, startDateAfter: string) => ['venue-ads', 'count', venueId, startDateAfter],
    },
    MERCHANT: {
      GET_ALL_CAMPAIGNS: (merchantId: string) => ['merchant-ads', merchantId],
      GET_CAMPAIGN: (merchantId: string, campaignId: string) => ['merchant-ads', merchantId, campaignId],
      GET_CAMPAIGN_CONFIG: (merchantId: string, country: Country) => [
        'merchant-ads',
        'configuration',
        merchantId,
        country,
      ],
      GET_CAMPAIGN_COUNT: (merchantId: string, startDateAfter: string) => [
        'merchant-ads',
        'count',
        merchantId,
        startDateAfter,
      ],
    },
  },
};
